import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00f246b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "区域", -1))
const _hoisted_3 = { class: "title-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "时间", -1))

import { ref, onMounted } from 'vue'
import Tab1 from './tab1.vue'
import Tab2 from './tab2.vue'
import Tab3 from './tab3.vue'
import Tab4 from './tab4.vue'
import dayjs, { Dayjs } from 'dayjs'
import { shareInfo } from '@dc-platform/dc-interaction'
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'


const __default__ = { name: 'DcCosFbuDataBoardRegion' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const formState = ref({
  customerRegionEmployeeNoList: [],
  date: dayjs(),
  deptId: undefined,
  startDay: dayjs().startOf('month').format('YYYY/MM/DD'),
  endDay: dayjs().endOf('month').format('YYYY/MM/DD')
})

const regionListRef = ref([])

const fetchRegionList = () => {
  request.post<AxiosResult, AxiosResult>('/fbu/api/report/region/list', { deptManagerId: shareInfo.getUserInfo().work_code }).then((res) => {
    const { deptId, regionList } = res.data
    if (!deptId || !regionList) return
    regionList.forEach((item: any) => {
      item.label = item.deptName
      item.value = item.deptId
    })
    regionListRef.value = regionList
    const region = regionList.find((item: any) => item.deptId === deptId) || regionList[0]
    formState.value.deptId = region.deptId
    formState.value.customerRegionEmployeeNoList = region.deptScope || []
    formState.value.region = region
    fetchData()
  })
}

const fetchData = () => {
  const p = { ...formState.value }
  const { deptId, date } = formState.value
  if (!deptId) return
  p.startDay = dayjs(date).startOf('month').format('YYYY/MM/DD')
  p.endDay = dayjs(date).endOf('month').format('YYYY/MM/DD')
  const region = regionListRef.value.find((item: any) => item.deptId === deptId)
  p.customerRegionEmployeeNoList = region?.deptScope || []
  p.region = region
  formState.value = p
}

onMounted(() => {
  fetchRegionList()
})

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createVNode(_component_CosSelect, {
                      style: {"width":"80%"},
                      value: formState.value.deptId,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.value.deptId) = $event)),
                      placeholder: "请选择",
                      options: regionListRef.value,
                      allowClear: false,
                      onChange: fetchData
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode(_component_a_date_picker, {
                      style: {"width":"80%"},
                      value: formState.value.date,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.value.date) = $event)),
                      allowClear: false,
                      onChange: fetchData,
                      picker: "month"
                    }, null, 8, ["value"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_tabs, { "default-active-key": "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tab_pane, {
                key: "1",
                tab: "销售线索&商机"
              }, {
                default: _withCtx(() => [
                  _createVNode(Tab1, { formState: formState.value }, null, 8, ["formState"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "2",
                tab: "客户过程管理"
              }, {
                default: _withCtx(() => [
                  _createVNode(Tab2, { formState: formState.value }, null, 8, ["formState"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "3",
                tab: "客户营收管理"
              }, {
                default: _withCtx(() => [
                  _createVNode(Tab3, { formState: formState.value }, null, 8, ["formState"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "4",
                tab: "客户风控管理"
              }, {
                default: _withCtx(() => [
                  _createVNode(Tab4, { formState: formState.value }, null, 8, ["formState"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})